var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bankAccountHoldStore.hasActiveHolds)?_c('span',{staticClass:"text-danger hold-alert"},[_vm._v("Account on Hold")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }